import { AnimatePresence, motion } from 'framer-motion';
import { useGetParams } from '../../hooks/useGetParams';

import { iconsSources } from '../../helpers/icons';
import { hideNumber } from '../../helpers/titreHelper';

import { Photo } from '../Photo/Photo';
import styles from './Message.module.css';
import { useEffect, useState } from 'react';

const Message = ({ message, rotateSign }) => {
  const { duration } = useGetParams();

  const [isFirst, setIsFirst] = useState(true);

  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel];
  };

  useEffect(() => {
    setIsFirst(false);
  }, []);

  return (
    <div className={styles.msgWrapper}>
      <AnimatePresence mode="wait">
        {message && (
          <motion.div
            initial={{ y: '100%' }}
            animate={{ y: '0' }}
            key={message.id}
            exit={{ y: '-100%' }}
            transition={{ duration: 1, delay: isFirst ? 0.6 : 0 }}
            className={styles.wrapper}
          >
            <div className={styles.avatarBlock}>
              <div className={styles.avatar}>
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 1, delay: 0.2 }}
                  className={styles.avatarBg}
                  style={{
                    background: `url(${
                      iconsSources[message?.channel]
                    }) center/cover no-repeat `,
                  }}
                />
                <motion.img
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 1, delay: 0.2 }}
                  src={
                    (message?.image !== '1' && message?.image) ||
                    iconsSources[message?.channel]
                  }
                  alt=""
                  onError={errorHandler}
                />
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 1 }}
                  className={styles.backImg}
                />
              </div>

              <div className={styles.author}>
                {message.author || hideNumber(message?.senderNumber)}
              </div>
            </div>
            <motion.div
              key={message.id}
              initial={{ scale: 1 }}
              animate={{ scale: 1.1 }}
              transition={{ duration: Number(duration) / 1000 - 1, delay: 1 }}
              className={styles.photoBlock}
            >
              <Photo message={message} rotateSign={rotateSign} />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Message;
